import React, { ChangeEvent } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IRootState, IRootThunkDispatch } from "../../redux/store";
import { Button, Grid } from "@mui/material";
import styles from "./unloadImage.module.css";
import { isSuperAdmin } from "../../util/form/form";
import { CleaningDetailImageList } from "../../redux/cleaning/state";
import { initCleaningDetailRoutePhotoThunk } from "../../redux/cleaning/thunk";
import { OpenLoadingBarThunk } from "../../redux/common/isLoading/thunk";
import { axiosPostWithFormData } from "../../util/axios";
import { Moment } from "moment";
import { initImageListThunk } from "../../redux/collection/thunk";
import axios from "axios";
import { UnloadImageList } from "../../redux/collection/state";

interface Props {
    selectedUnloadId: number;
    selectedUnloadDetailId: number;
    selectedUnloadDate: Date | Moment | string;
}

function UnloadImages(props: Props) {
    const dispatch = useDispatch<IRootThunkDispatch>();
    const { unloadImageList } = useSelector(
        (state: IRootState) => state.collectionState
    );
    const { user } = useSelector((state: IRootState) => state.userAuth);
    const isSuperAdminRole = isSuperAdmin(user?.token?.role_id as number);

    async function handleChangeUnloadPhoto(
        event: ChangeEvent<HTMLInputElement>
    ) {
        const files = event.target.files;
        if (!files) return;
        const form = new FormData();
        form.append("unload_date", props.selectedUnloadDate?.toString() ?? "");
        form.append(
            "unload_detail_id",
            props.selectedUnloadDetailId.toString()
        );
        const file = files[0];
        form.append("unload_image", file);
        dispatch(OpenLoadingBarThunk(true));
        const res = await axiosPostWithFormData(
            "api/unload/attendacePhoto/" + props.selectedUnloadId,
            form
        );
        if (res.data.success && res.data.record && res.data.record.length) {
            const unloadPhotoListTmp = JSON.parse(
                JSON.stringify(unloadImageList)
            );
            unloadPhotoListTmp.push(res.data.record[0]);
            dispatch(initImageListThunk(unloadPhotoListTmp));
        }
        dispatch(OpenLoadingBarThunk(false));
    }

    return (
        <>
            {isSuperAdminRole && (
                <>
                    <input
                        accept="image/*"
                        id="photo-upload-button1"
                        type="file"
                        style={{ display: "none" }}
                        multiple
                        onChange={handleChangeUnloadPhoto}
                    />
                    <label htmlFor="photo-upload-button1">
                        <Button variant="contained" component="span">
                            添加相片
                        </Button>
                    </label>
                </>
            )}
            <Grid className={styles.UnloadPhotoOuterContainer}>
                {unloadImageList.map((image, index) => (
                    <Grid
                        key={`unload_image-${index}`}
                        className={styles.UnloadPhotoContainer}
                    >
                        <img
                            src={`${process.env.REACT_APP_S3}${image.image}`}
                            width={"100%"}
                            height={"90%"}
                            style={{ objectFit: "cover" }}
                        ></img>
                        {isSuperAdminRole && (
                            <Button
                                variant="contained"
                                onClick={async () => {
                                    const token =
                                        localStorage.getItem("loginToken");
                                    dispatch(OpenLoadingBarThunk(true));
                                    const res = await axios.delete(
                                        process.env.REACT_APP_API +
                                            "api/unload/attendacePhoto/" +
                                            image.unload_image_id,
                                        {
                                            headers: {
                                                ...{
                                                    Authorization: `Bearer ${token}`,
                                                },
                                            },
                                        }
                                    );
                                    if (res.data.success) {
                                        let unloadPhotoListTmp = JSON.parse(
                                            JSON.stringify(unloadImageList)
                                        );
                                        unloadPhotoListTmp =
                                            unloadPhotoListTmp.filter(
                                                (obj: UnloadImageList) =>
                                                    obj.unload_image_id !==
                                                    image.unload_image_id
                                            );
                                        dispatch(
                                            initImageListThunk(
                                                unloadPhotoListTmp
                                            )
                                        );
                                    }
                                    dispatch(OpenLoadingBarThunk(false));
                                }}
                                style={{
                                    marginTop: "10px",
                                    marginBottom: "10px",
                                }}
                            >
                                刪除照片
                            </Button>
                        )}
                    </Grid>
                ))}
            </Grid>
        </>
    );
}

export default UnloadImages;
